import { setSettings } from '@/utils';
import uid from 'easy-uid';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalFooter } from '@/components/atom';
import { PresetEntryContainer } from '@/components/molecule';
import styles from './presetsModal.module.less';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default class PresetsModal extends React.PureComponent {
  static get propTypes() {
    return {
      presets: PropTypes.object,
      selectedPresetId: PropTypes.string,
      opened: PropTypes.bool.isRequired,
      addPreset: PropTypes.func,
      selectPreset: PropTypes.func,
      alertSuccess: PropTypes.func,
      onClose: PropTypes.func.isRequired
    };
  }
  render() {
    const {
      opened,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      onClose: onClose,
      title: 'Presets',
      className: styles.modal,
      opened: opened,
      children: [this._renderModalBody(), this._renderModalFooter()]
    });
  }
  _renderModalBody() {
    const {
      presets
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: styles.body,
      children: Object.keys(presets).map(id => {
        return /*#__PURE__*/_jsx(PresetEntryContainer, {
          onClick: () => this.onSelect(id),
          id: id
        }, id);
      })
    });
  }
  _renderModalFooter() {
    const {
      onClose
    } = this.props;
    return /*#__PURE__*/_jsxs(ModalFooter, {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: e => this.onSaveChanges(e),
        color: "success",
        children: "Save Preset Changes"
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: e => this.onCreatePreset(e),
          color: "primary",
          children: "Create Preset"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: "Close"
        })]
      })]
    });
  }
  onCreatePreset(e) {
    e.preventDefault();
    const {
      addPreset
    } = this.props;
    addPreset(this._createPreset());
  }
  onSaveChanges(e) {
    e.preventDefault();
    const {
      presets,
      selectedPresetId,
      alertSuccess
    } = this.props;
    setSettings({
      presets,
      selectedPresetId
    });
    alertSuccess('Changes made to the presets were saved.');
  }
  onSelect(id) {
    const {
      selectPreset,
      onClose
    } = this.props;
    selectPreset(id);
    onClose();
  }
  _createPreset() {
    const id = uid();
    return {
      id,
      name: `Preset - ${id.substring(0, 6)}`,
      editable: true,
      selected: false,
      hooks: {}
    };
  }
}